import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/teachers/TeacherResult.css";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const TeacherResult = () => {
  const [course, setCourse] = useState("");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTable, setShowTable] = useState(false);
  const [sent, setSent] = useState(false);
  const [saved, setSaved] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [className, setClassName] = useState("");
  const [section, setSection] = useState("");
  const [subject, setSubject] = useState("");
  const [marks, setMarks] = useState("");
  const [grade, setGrade] = useState("");
  const [remarks, setRemarks] = useState("");
  const [showResultTable, setShowResultTable] = useState(false);
  const [students, setStudents] = useState([]);
  const { baseUrl, loggedInTeacher } = useContext(AppContext);
  // Initialize 5 rows for student results
  // const initialResults = Array.from({ length: 5 }, () => ({
  //   studentName: "",
  //   rollNo: "",
  //   className: "",
  //   section: "",
  //   subject: "",
  //   marks: "",
  //   grade: "",
  //   remarks: "",
  // }));
  const saveAllResults = async () => {
    try {
      // Course check
      if (!course) {
        alert("Please select a course first");
        return;
      }

      // Students check
      if (students.length === 0) {
        alert("No students found");
        return;
      }

      // Check if any student has no marks
      const missingMarks = students.some(
        (student) =>
          student.obtainMarks === "" ||
          student.obtainMarks === null ||
          student.obtainMarks === undefined,
      );

      if (missingMarks) {
        alert("Please enter marks for all students");
        return;
      }

      // Save all students
      for (const student of students) {
        const formData = new FormData();

        formData.append("ngteacher_id", loggedInTeacher.id);
        formData.append("ngstudent_id", student.ngstudent.id);
        formData.append("ngcourse_id", course);
        formData.append("obtainMarks", student.obtainMarks);

        console.log("Sending Result:", {
          teacher_id: loggedInTeacher.id,
          student_id: student.ngstudent.id,
          course_id: course,
          obtainMarks: student.obtainMarks,
        });

        const response = await axios.post(
          `${baseUrl}/teacher/result/createTeacherResult`,
          formData,
        );

        console.log("Backend Response:", response.data);
      }

      alert("All Results Uploaded Successfully");
    } catch (error) {
      console.log("Result Save Error:", error);
      console.log("Status:", error.response?.status);
      console.log("Response:", error.response?.data);

      alert(
        error.response?.data?.message || "Result save karte waqt error aa gaya",
      );
    }
  };
  const saveResult = (student) => {
    const formData = new FormData();

    formData.append("ngteacher_id", loggedInTeacher.id);

    // formData.append("ngstudent_id",student.id);
    formData.append("ngstudent_id", student.ngstudent.id);

    formData.append("ngcourse_id", course);

    formData.append("obtainMarks", student.obtainMarks);

    axios
      .post(`${baseUrl}/teacher/result/createTeacherResult`, formData)
      .then((response) => {
        alert("Result Uploaded");
      })
      .catch((error) => {
        console.log(error);
      });
  };
 const loadStudents = (courseId) => {
  axios
    .get(`${baseUrl}/teacher/result/fetchStudents/${courseId}`)
    .then((response) => {
      console.log("Students:", response.data);

      if (response.data.success) {
        setStudents(
          response.data.students.map((student) => ({
            ...student,
            obtainMarks: "",
          }))
        );
      }
    })
    .catch((error) => {
      console.log("Status:", error.response?.status);
      console.log("Response:", error.response?.data);
    });
};


  const handleMarksChange = (index, value) => {
    const updated = [...students];

    updated[index].obtainMarks = value;

    setStudents(updated);
  };
  const [resultData, setResultData] = useState([]);
  // const [resultData, setResultData] = useState(initialResults);

  const handleChange = (index, e) => {
    const newData = [...resultData];
    newData[index][e.target.name] = e.target.value;
    setResultData(newData);
  };

  const handleSave = () => {
    console.log("Saved Result:", resultData);
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };
  const viewAllTeacherCourse = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("ngteacher_id", loggedInTeacher?.id);
    axios
      .post(`${baseUrl}/teacher/result/viewAllTeacherCourse`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setCourses(response.data.courses);
        }
        setLoading(false);
      })
      .catch((error) => {
        // console.log(error);

        console.log("Status:", error.response?.status);
        console.log("Response:", error.response?.data);

        setLoading(false);
      });
  };

  // useEffect(() => {
  //   viewAllTeacherCourse();
  // }, []);
  useEffect(() => {
    if (loggedInTeacher?.id) {
      viewAllTeacherCourse();
    }
  }, [loggedInTeacher]);
  return (
    <TeacherMasterLayout>
      {/* Topbar */}
      <header className="ta-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="ta-profile">👤</div>
      </header>
      <div className="tp-result-container">
        <h2 className="tp-result-title">Result Management</h2>

        <div className="tp-result-card">
          {/* Select Course */}
          <div className="tp-result-group">
            {/* <label>Select Course</label> */}
            {/* <select value={course} onChange={(e) => setCourse(e.target.value)}>
              <option value="">-- Select Course --</option>

              {courses.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.ngcourse?.name}
                </option>
              ))}
            </select> */}
            <div className="tp-course-list">
              {courses.map((item) => (
                <div className="tp-course-card" key={item.id}>
                  <div className="tp-course-left">
                    <h3>{item.ngcourse?.name}</h3>

                    <p>Course ID : {item.ngcourse_id}</p>
                  </div>

                  <div className="tp-course-right">
                    {/* <button
                      className="tp-btn-primary"
                      onClick={() => {
                        setCourse(item.ngcourse_id);
                        setShowResultTable(true);
                        loadStudents(item.ngcourse_id);
                      }}
                    >
                      Upload Result
                    </button> */}
                    <button
                      className={
                        course === item.ngcourse_id
                          ? "tp-btn-uploaded"
                          : "tp-btn-primary"
                      }
                      onClick={() => {
                        setCourse(item.ngcourse_id);
                        setShowResultTable(true);
                        loadStudents(item.ngcourse_id);
                      }}
                    >
                      {course === item.ngcourse_id
                        ? "Result Opened ✓"
                        : "Upload Result"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Upload Marks */}
          {/* <div className="tp-result-group">
            <label>Upload Marks</label>
            <input type="file" />
            <small>Upload CSV / Excel File</small>
          </div> */}

          {/* Auto Grade */}
          {/* <div className="tp-result-grade">
            <h4>Auto Grade Generation</h4>
            <p>Grade will be calculated based on marks.</p>
          </div> */}

          {/* Actions */}
          <div className="tp-result-actions">
            {/* <button
              className="tp-btn-primary"
              onClick={() => setShowTable(true)}
            >
              Generate Result
            </button> */}

            {/* <button
              className="tp-btn-secondary"
              onClick={() => setSent(true)}
            >
              Send to Admin & Students
            </button> */}
          </div>

          {sent && (
            <p className="tp-success-msg">✅ Result sent to Admin & Students</p>
          )}

          {/* ===== RESULT TABLE ===== */}
          {showResultTable && (
            <div className="tp-result-table-wrapper">
              <h3 className="tp-table-title">Upload Student Result</h3>

              <table className="tp-result-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Student ID</th>
                    <th>Student Name</th>
                    <th>Obtain Marks</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>

                <tbody>
                  {students.map((student, index) => (
                    // <tr key={student.id}>
                    <tr key={student.ngstudent.id}>
                      <td>{index + 1}</td>

                      {/* <td>{student.id}</td>

                      <td>{student.fullname}</td> */}
                      <td>{student.ngstudent?.id}</td>

                      <td>{student.ngstudent?.fullname}</td>

                      <td>
                        <input
                          type="number"
                          value={student.obtainMarks}
                          onChange={(e) =>
                            handleMarksChange(index, e.target.value)
                          }
                        />
                      </td>

                      {/* <td>
                        <button
                          className="tp-good-btn"
                          onClick={() => saveResult(student)}
                        >
                          Good
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="tp-form-actions">
                <button
                  className="tp-btn-secondary"
                  onClick={() => setShowResultTable(false)}
                >
                  Close
                </button>

                <button className="tp-btn-primary" onClick={saveAllResults}>
                  Save Result
                </button>
              </div>
            </div>
          )}
          {/* {showTable && (
            <div className="tp-result-table-wrapper">
              <h3 className="tp-table-title">Student Result Sheet</h3>

              <table className="tp-result-table">
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Roll No</th>
                    <th>Class</th>
                    <th>Section</th>
                    <th>Subject</th>
                    <th>Marks</th>
                    <th>Grade</th>
                  </tr>
                </thead>
                <tbody>
                  {resultData.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          name="studentName"
                          placeholder="Student Name"
                          value={row.studentName}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          name="rollNo"
                          placeholder="Roll No"
                          value={row.rollNo}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          name="className"
                          placeholder="Class"
                          value={row.className}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          name="section"
                          placeholder="Section"
                          value={row.section}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          name="subject"
                          placeholder="Subject"
                          value={row.subject}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name="marks"
                          placeholder="Marks"
                          value={row.marks}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          name="grade"
                          placeholder="Grade"
                          value={row.grade}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <textarea
                className="tp-remarks"
                name="remarks"
                placeholder="Remarks"
              />

              {saved && (
                <p className="tp-success-msg">✅ Result Saved Successfully</p>
              )}

              <div className="tp-form-actions">
                <button
                  className="tp-btn-secondary"
                  onClick={() => setShowTable(false)}
                >
                  Close
                </button>
                <button className="tp-btn-primary" onClick={handleSave}>
                  Send to Admin & Students
                </button>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </TeacherMasterLayout>
  );
};

export default TeacherResult;
